var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sidebar", attrs: { id: "sidebar" } }, [
      _c(
        "div",
        { staticClass: "sidebar-inner", attrs: { id: "style-15" } },
        [
          _c(
            "vue-custom-scrollbar",
            {
              staticClass: "scroll-area",
              attrs: { settings: _vm.settings },
              on: { "ps-scroll-x": _vm.scrollHanle }
            },
            [
              _c(
                "div",
                { staticClass: "sidebar-menu", attrs: { id: "sidebar-menu" } },
                [
                  _vm.isOwner == true
                    ? _c("ul", [
                        _c("li", { staticClass: "menu-title" }, [
                          _c("span", [_vm._v("Dashboard")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage === "/index" ||
                                _vm.currentpage === "/"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/index" }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-television",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Monitoring")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: { active: _vm.currentpage === "/instagram" }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/instagram" }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-instagram",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Instagram")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("li", { staticClass: "menu-title" }, [
                          _c("span", [_vm._v("Monitoring")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage === "/monitoring/scrape/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/monitoring/scrape/list" }
                              },
                              [
                                _c("i", {
                                  staticClass: "la la-cloud-download"
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Scrape")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage === "/monitoring/logs/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/monitoring/logs/list" }
                              },
                              [
                                _c("i", { staticClass: "la la-folder" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Logs")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage === "/monitoring/links/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/monitoring/links/list" }
                              },
                              [
                                _c("i", { staticClass: "la la-link" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Links")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage === "/monitoring/bookmarks/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/monitoring/bookmarks/list" }
                              },
                              [
                                _c("i", { staticClass: "la la-bookmark" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Bookmarks")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage === "/monitoring/trash/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/monitoring/trash/list" }
                              },
                              [
                                _c("i", { staticClass: "la la-trash" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Trash")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("li", { staticClass: "menu-title" }, [
                          _c("span", [_vm._v("Statistik")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active: _vm.currentpage === "/statistik/harian"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/statistik/harian" }
                              },
                              [
                                _c("i", { staticClass: "la la-clipboard" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Harian")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active: _vm.currentpage === "/statistik/brands"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/statistik/brands" }
                              },
                              [
                                _c("i", { staticClass: "la la-clipboard" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Brands")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active: _vm.currentpage === "/statistik/products"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/statistik/products" }
                              },
                              [
                                _c("i", { staticClass: "la la-clipboard" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Products")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("li", { staticClass: "menu-title" }, [
                          _c("span", [_vm._v("Instagram Unofficial API")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage === "/instagram/accounts/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/instagram/accounts/list" }
                              },
                              [
                                _c("i", { staticClass: "la la-user" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Accounts")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active: _vm.currentpage === "/instagram/post/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/instagram/post/list" }
                              },
                              [
                                _c("i", { staticClass: "la la-image" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Post Schedule")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active: _vm.currentpage === "/instagram/logs/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/instagram/logs/list" }
                              },
                              [
                                _c("i", { staticClass: "la la-image" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Logs")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("li", { staticClass: "menu-title" }, [
                          _c("span", [_vm._v("Instagram Official API")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage ===
                                "/instagram/accounts/list_official"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: {
                                  to: "/instagram/accounts/list_official"
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-user" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Accounts")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage ===
                                "/instagram-official/post/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/instagram-official/post/list" }
                              },
                              [
                                _c("i", { staticClass: "la la-image" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Post Schedule")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage ===
                                "/instagram-official/logs/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/instagram-official/logs/list" }
                              },
                              [
                                _c("i", { staticClass: "la la-image" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Logs")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("li", { staticClass: "menu-title" }, [
                          _c("span", [_vm._v("Client")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active: _vm.currentpage === "/client/brands/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/client/brands/list" }
                              },
                              [
                                _c("i", { staticClass: "fa fa-tags" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Brands")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage === "/client/products/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/client/products/list" }
                              },
                              [
                                _c("i", { staticClass: "la la-tree" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Products")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active: _vm.currentpage === "/client/seller/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/client/seller/list" }
                              },
                              [
                                _c("i", {
                                  staticClass: "la la-exclamation-circle"
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Exclude Seller")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active: _vm.currentpage === "/client/agents/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "agents",
                                attrs: { to: "/client/agents/list" }
                              },
                              [
                                _c("i", { staticClass: "la la-user" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Agents")])
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _c("ul", [
                        _c("li", { staticClass: "menu-title" }, [
                          _c("span", [_vm._v("Dashboard")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active: _vm.currentpage === "/index-agent"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/index-agent" }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-television",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Monitoring")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("li", { staticClass: "menu-title" }, [
                          _c("span", [_vm._v("Monitoring")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage ===
                                "/monitoring-agent/links/list"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/monitoring-agent/links/list" }
                              },
                              [
                                _c("i", { staticClass: "la la-link" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Links")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("li", { staticClass: "menu-title" }, [
                          _c("span", [_vm._v("Statistik")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage === "/statistik-agent/harian"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/statistik-agent/harian" }
                              },
                              [
                                _c("i", { staticClass: "la la-clipboard" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Harian")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage === "/statistik-agent/brands"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/statistik-agent/brands" }
                              },
                              [
                                _c("i", { staticClass: "la la-clipboard" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Brands")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active:
                                _vm.currentpage === "/statistik-agent/products"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "clients",
                                attrs: { to: "/statistik-agent/products" }
                              },
                              [
                                _c("i", { staticClass: "la la-clipboard" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Products")])
                              ]
                            )
                          ],
                          1
                        )
                      ])
                ]
              )
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ce768d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ce768d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Sidebar.vue
// module id = null
// module chunks = 